import axiosInstance from "../app/axios";
import DefaultPaginationProps from "../propInterfaces/defaultPaginationProps";
import PushNotificationDTO from "../shared/dtos/pushNotificationDTO";

export const createPushNotification = async (
  pushNotification: PushNotificationDTO,
) => {
  const result = await axiosInstance.post("notifications", pushNotification);

  return result;
};

export const updatePushNotification = async (
  id: number,
  pushNotification: PushNotificationDTO,
) => {
  const result = await axiosInstance.patch(
    `notifications/${id}`,
    { ...pushNotification, sentAt: null },
  );

  return result;
};

export const deletePushNotification = async (id: number) => {
  const result = await axiosInstance.delete(`notifications/${id}`);
  return result.data;
};

export const sendPushNotification = async (id: number) => {
  const result = await axiosInstance.post(`notifications/push/${id}`);
  return result.data;
};

export const getPushNotifications = async ({
  page,
  take,
}: DefaultPaginationProps) => {
  const result = await axiosInstance.get(
    `notifications?page=${page}&take=${take}`,
  );
  return result.data;
};
